/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, filter, Observable, take, throwError } from 'rxjs';
import { AuthService } from '@data-access/user/services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';
import { UsersStore } from '@data-access/user/stores/users.store';

@Injectable({providedIn: 'root'})
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private aa = Math.random();
  private userStore = inject(UsersStore);
  private authService = inject(AuthService);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.authService.getAccessToken()) {
      request = this.addToken(request, this.authService.getAccessToken()!);
    }

    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (!request.url.endsWith('/refresh') && !request.url.endsWith('/signin')) {
          return this.handle401Error(request, next);
        } else {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(null);
          if (error.status === 401 && !request.url.endsWith('/signin')) {
            console.log( error);
            this.userStore.logout();
          }

          return throwError(error);
        }
      } else {
        this.isRefreshing = false;
        this.refreshTokenSubject.next(null);
        return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;

          if (token) {
            this.refreshTokenSubject.next(token.session.access_token);
            return next.handle(this.addToken(request, token.session.access_token));
          }

          this.authService.logout();
          return throwError(() => 'Token expired');
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}
